import api from "./api";

const route = '/fornecedores/permissoes';
const routeUser = '/fornecedores/usuarios/permissoes/';

export const ROLE_TYPE = {
  BIBI: 'bibi',
  SUPPLIER: 'supplier'
}

export const PermissionService = {
  async all(roleType) {
    let params = {}
    if (roleType === ROLE_TYPE.BIBI) {
      params = { bibi: true }
    } else {
      params = { fornecedor: true }
    }
    const response = await api.get(route, {
      params
    })
    return response.data
  },

  async deleteUser(id) {
    return await api.delete(`/fornecedores/usuarios/${id}`);
  },

  async updateUser(id, tipo) {
    return await api.put(`/fornecedores/usuarios/${id}`, { TIPO: tipo });
  },

  async getByUser(email, supplier) {
    let params = { email };
    if (supplier) {
      params = { ...params, supplierId: supplier }
    }
    const response = await api.get(`${routeUser}`, {
      params
    })
    return response.data
  },

  async add(email, id) {
    const response = await api.post(`${routeUser}`, {
      email, permissionId: id
    })
    return response.data
  },

  async remove(id, email) {
    const response = await api.delete(`${routeUser}${id}`, {
      params: { email }
    })
    return response.data
  }
}